<template>
  <div style="padding: 5px;">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Choose Azure AD account" prop="oid">
        <a-select
          show-search
          placeholder="Nhập ký tự đầu để tìm"
          style="width: 100%;"
          :filter-option="false"
          :not-found-content="fetching ? undefined : null"
          :loading="getMsUsersLoadding"
          @search="searchMsUser"
          @change="changeUser"
        >
          <!--          <a-select-->
          <!--          show-search-->
          <!--          placeholder="Nhập ký tự đầu để tìm"-->
          <!--          style="width: 100%"-->
          <!--          :filter-option="false"-->
          <!--          :not-found-content="fetching ? undefined : null"-->
          <!--          :loading="getMsUsersLoadding"-->
          <!--          @search="searchMsUser"-->
          <!--          @change="changeUser"-->
          <!--          v-model="ctPhongBan.oid"-->
          <!--        >-->
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="d in msUsers" :key="d.id">
            {{ d.displayName || i.givenName || i.mail }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item has-feedback label="Mã nhân viên" prop="employeeCode">
        <a-input v-model="form.employeeCode" placeholder="Nhập mã nhân viên" />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Username" prop="username">
        <a-input v-model="form.username" placeholder="Username" />
      </a-form-model-item>
      <a-form-model-item has-feedback label="Họ và tên" prop="fullname">
        <a-input v-model="form.fullname" placeholder="Nhập đầy đủ họ và tên" />
      </a-form-model-item>

      <a-form-model-item has-feedback label="Email" prop="email">
        <a-input v-model="form.email" placeholder="Nhập email" disabled />
      </a-form-model-item>

      <a-form-model-item label="Chức vụ" prop="position">
        <SelectPosition
          v-model="form.positionId"
          :selectProps="{
            style: { width: '100%' },
            placeholder: 'Chọn chức vụ',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Phòng ban" prop="department">
        <SelectDepartment
          v-model="form.departmentId"
          :selectProps="{
            style: { width: '100%' },
            placeholder: 'Chọn phòng ban',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Admin of location / Admin của chi nhánh này">
        <SelectBranchLocation
          v-model="form.adminOfLocationId"
          :selectProps="{
            value: form.adminOfLocationId || undefined,
            style: { width: '100%' },
            placeholder: 'Admin of location',
          }"
        />
      </a-form-model-item>
      <a-form-model-item label="Status">
        <a-checkbox v-model="form.status">
          Active
        </a-checkbox>
      </a-form-model-item>
    </a-form-model>

    <div
      style="text-align: right;"
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 5px;" @click="closeDrawer">
        <a-icon type="left" />Quay lại
      </a-button>
      <a-button
        type="primary"
        @click="createEmployee"
        icon="save"
        :loading="iconLoading"
      >
        Lưu
      </a-button>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import postQuery from "../data/postData";
import changeAlias from "@/services/changeAlias";
import SelectPosition from "@/components/common/position/select";
import SelectDepartment from "@/components/common/department/select";
import SelectBranchLocation from "@/components/common/branchLocation/select";

const DEFAULT_FORM = {
  status: true,
  employeeCode: undefined,
  username: undefined,
  email: undefined,
  fullname: undefined,
  positionId: undefined,
  departmentId: undefined,
  oid: undefined,
  adminOfLocationId: undefined,
};

export default {
  components: {
    SelectPosition,
    SelectDepartment,
    SelectBranchLocation,
  },
  props: {
    closeDrawer: {
      type: Function,
    },
    updateListAfterCreated: {
      type: Function,
    },
  },
  data() {
    let checkCode = (rule, value, callback) => {
      if (!this.regCode.test(this.form.code)) {
        callback(
          new Error(
            "Mã nhân viên yêu cầu tối thiểu 4 ký tự, không được trùng, không dấu cách, không dấu,ký tự đặc biệt trừ dấu _"
          )
        );
      } else {
        callback();
      }
    };
    let checkEmail = (rule, value, callback) => {
      if (!this.regEmail.test(this.form.email)) {
        if (this.form.email) {
          callback(
            new Error(
              "Email này không hợp lệ. Hãy đảm bảo rằng email được nhập dưới dạng example@email.com"
            )
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      msUsers: [],
      getMsUsersLoadding: false,
      // isSubmiting: false,
      fetching: false,
      iconLoading: false,
      form: {
        ...DEFAULT_FORM,
      },
      regEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      regCode: /^\w{4,100}$/,
      rules: {
        // employeeCode: [
        //   {
        //     required: true,
        //     message: "Mã nhân viên không được bỏ trống",
        //     trigger: "change",
        //   },
        //   { validator: checkCode, trigger: "change" },
        // ],

        email: [{ validator: checkEmail, trigger: "change" }],
        oid: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
        fullname: [
          {
            required: true,
            message: "Required",
            trigger: "change",
          },
        ],
      },
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth;
    },
  },
  methods: {
    searchFilter(input, option) {
      return (
        changeAlias(option.componentOptions.children[0].text).indexOf(
          changeAlias(input)
        ) >= 0
      );
    },
    goToListEmployee() {
      this.$router.push({
        name: "employee",
      });
    },
    createEmployee() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.iconLoading = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryCreateUser,
              variables: {
                ...this.form,
                password: new Date().toISOString(),
                status: this.form.status ? "ACTIVE" : "DEACTIVE",
              },
            })
            .then((data, errors) => {
              console.log(data);
              this.$notification.success({
                message: "Thông báo",
                description: "Thêm nhân viên thành công !",
              });
              this.iconLoading = false;
              if (data?.data?.createUser?.id) {
                this.updateListAfterCreated(data.data.createUser);
              }
              this.form = {};
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description:
                  "Mã nhân viên hoặc email bị trùng hoặc ngày sinh bạn chọn không đúng",
              });
              console.log("Không lấy được danh sách nhân viên", error);
              this.iconLoading = false;
            });
        } else {
          return false;
        }
      });
    },
    searchMsUser(searchString) {
      if (searchString) {
        this.fetching = true;
        const query = `?$select=id,displayName,givenName,mail,employeeId&$filter=startswith(displayName,'${searchString}') or startswith(givenName,'${searchString}') or startswith(surname,'${searchString}') or startswith(mail,'${searchString}') or startswith(userPrincipalName,'${searchString}')`;

        this.getMsUsersLoadding = true;
        axios({
          method: "get",
          url: "https://graph.microsoft.com/v1.0/users" + query,
          headers: {
            Authorization: "Bearer " + this.currentUser.msToken,
          },
        })
          .then(({ data }) => {
            this.getMsUsersLoadding = false;
            if (data && data.value) {
              this.msUsers = data.value;
            }
            this.fetching = false;
          })
          .catch((error) => {
            this.getMsUsersLoadding = false;
            this.fetching = false;
            console.log("Lỗi Graph", error);
          });
      }
    },
    // Auto change user follow from Ms Graph
    changeUser(eventData) {
      const selectedUser = this.msUsers.find((e) => e.id === eventData);
      if (selectedUser) {
        this.form.username = this.suggestUsername(selectedUser.mail);
        this.form.oid = selectedUser.id;
        this.form.email = selectedUser.mail;
        this.form.fullname = selectedUser.displayName;
        this.form.employeeCode = selectedUser.employeeId;
        this.form.adminOfLocationId = selectedUser.adminOfLocationId;
      }
    },
    // helper to convert email to username
    suggestUsername(email) {
      if (email && typeof email === "string" && email.trim().length > 0) {
        const [username] = email.split("@");
        if (username) return username;
        return "";
      }
      return "";
    },
  },
};
</script>
<style></style>
